import locales from '../assets/locales.json'
import city_airports from '../assets/city_airports.json'

export const airportNameByIata = (airport_iata: string): string => {
  return locales['ru']['airports'][
    airport_iata as keyof typeof locales['ru']['airports']
  ]
}

export const cityNameByIata = (city_iata: string): string => {
  return locales['ru']['cities'][
    city_iata as keyof typeof locales['ru']['cities']
  ]['nominative']
}

export const cityNameByAirportIata = (airport_iata: string): string => {
  const cityIata: string = cityByAirport(airport_iata)
  return cityNameByIata(cityIata)
}

export const cityByAirport = (airport_iata: string): string => {
  return city_airports[airport_iata as keyof typeof city_airports]
}
